module.exports = __webpack_public_path__ + "img/panel-line.b59f17f7.svg";